import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlayoffService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  // [GET] tournament playoffs
  public getTournamentPlayoffs(tournamentId: string): Observable<{ [index: string]: any; }> {
    return this.httpClient.get<HttpResponse<object>>
      (environment.api_server + _.replace(environment.api_endpoints.tournamentPlayoffs, ':tournament', tournamentId), {
        params: {}, observe: 'response'
      });
  }

  // [POST] create tournament playoffs
  public createTournamentPlayoffs(tournamentId: string, type: string = 'chess'): Observable<{ [index: string]: any; }> {
    const apiEndpoint = _.reduce(
      [[':type', type], [':tournament', tournamentId]],
      (res, [key, replacement]) => _.replace(res, key!, replacement!),
      environment.api_endpoints.tournamentPlayoffsCreate
    );
    return this.httpClient.post<HttpResponse<object>>
      (environment.api_server + apiEndpoint, {
        params: {}, observe: 'response'
      });
  }
}
